<div bsModal #navigateSubFoldersModal="bs-modal" class="modal fade nsf-slider-right {{cssClasses}}" tabindex="-1"
  [config]="{backdrop: 'static', keyboard: false}">
  <div class="h-100 model-content-wrapper">
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content" style="background:#fff;display:flex;flex-direction:column;max-height:100vh !important;">
        <!-- Header: Breadcrumb + Close -->
        <div class="d-flex align-items-center justify-content-between" style="padding:12px 20px;border-bottom:1px solid #E5E7EB;flex-shrink:0;">
          <div class="nsf-breadcrumb">
            <lucide-icon name="folder-open" [size]="12" [strokeWidth]="2" class="text-gray-500 cursor-pointer" style="flex-shrink:0;"
              (click)="close()"></lucide-icon>
            <button *ngIf="showSourceLabel" type="button" class="nsf-breadcrumb-source vf-css-tooltip"
              (click)="close()" [attr.data-tooltip]="sourceLabel" [attr.aria-label]="sourceLabel">
              <span class="nsf-breadcrumb-label">{{ sourceLabel }}</span>
            </button>
            <div class="nsf-breadcrumb-path" *ngIf="itemBreadCrumb.length > 0">
              <ng-container *ngIf="!hasCollapsedBreadcrumbs; else collapsedBreadcrumbTrail">
                <ng-container *ngFor="let itemOfBC of itemBreadCrumb; let first = first; let last = last; trackBy: trackByBreadcrumbItem">
                  <lucide-icon *ngIf="showSourceLabel || !first" name="chevron-right" [size]="12" [strokeWidth]="2" class="nsf-breadcrumb-separator"></lucide-icon>
                  <button *ngIf="!last" type="button" class="nsf-breadcrumb-link"
                    [class.nsf-breadcrumb-link--drop-active]="isBreadcrumbDropActive(itemOfBC)"
                    title="{{ itemOfBC.name }}" (click)="goToSpecificLevel(itemOfBC)"
                    (dragover)="onBreadcrumbDragOver($event, itemOfBC)"
                    (dragleave)="onBreadcrumbDragLeave($event, itemOfBC)"
                    (drop)="onBreadcrumbDrop($event, itemOfBC)">
                    <span class="nsf-breadcrumb-label">{{ itemOfBC.name }}</span>
                  </button>
                  <span *ngIf="last" class="nsf-breadcrumb-current" title="{{ itemOfBC.name }}">
                    <span class="nsf-breadcrumb-label">{{ itemOfBC.name }}</span>
                  </span>
                </ng-container>
              </ng-container>
              <ng-template #collapsedBreadcrumbTrail>
                <ng-container *ngIf="leadingBreadcrumb as firstBreadcrumb">
                  <lucide-icon *ngIf="showSourceLabel" name="chevron-right" [size]="12" [strokeWidth]="2" class="nsf-breadcrumb-separator"></lucide-icon>
                  <button type="button" class="nsf-breadcrumb-link nsf-breadcrumb-link-leading"
                    [class.nsf-breadcrumb-link--drop-active]="isBreadcrumbDropActive(firstBreadcrumb)"
                    title="{{ firstBreadcrumb.name }}" (click)="goToSpecificLevel(firstBreadcrumb)"
                    (dragover)="onBreadcrumbDragOver($event, firstBreadcrumb)"
                    (dragleave)="onBreadcrumbDragLeave($event, firstBreadcrumb)"
                    (drop)="onBreadcrumbDrop($event, firstBreadcrumb)">
                    <span class="nsf-breadcrumb-label">{{ firstBreadcrumb.name }}</span>
                  </button>
                </ng-container>
                <ng-container *ngIf="collapsedBreadcrumbItems.length > 0">
                  <lucide-icon name="chevron-right" [size]="12" [strokeWidth]="2" class="nsf-breadcrumb-separator"></lucide-icon>
                  <div class="dropdown nsf-breadcrumb-overflow">
                    <button type="button" class="nsf-breadcrumb-overflow-trigger" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                      title="Show full path" aria-label="Show full path">
                      <lucide-icon name="ellipsis" [size]="14" [strokeWidth]="2"></lucide-icon>
                    </button>
                    <div class="dropdown-menu nsf-breadcrumb-overflow-menu">
                      <button *ngFor="let hiddenItem of collapsedBreadcrumbItems; trackBy: trackByBreadcrumbItem" type="button"
                        class="dropdown-item nsf-breadcrumb-overflow-item no-fill"
                        [class.nsf-breadcrumb-link--drop-active]="isBreadcrumbDropActive(hiddenItem)"
                        title="{{ hiddenItem.name }}"
                        (click)="goToSpecificLevel(hiddenItem)"
                        (dragover)="onBreadcrumbDragOver($event, hiddenItem)"
                        (dragleave)="onBreadcrumbDragLeave($event, hiddenItem)"
                        (drop)="onBreadcrumbDrop($event, hiddenItem)">
                        <lucide-icon name="folder" [size]="14" [strokeWidth]="2" class="nsf-breadcrumb-overflow-icon"></lucide-icon>
                        <span class="nsf-breadcrumb-overflow-copy">{{ hiddenItem.name }}</span>
                      </button>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngFor="let itemOfBC of trailingBreadcrumbItems; let last = last; trackBy: trackByBreadcrumbItem">
                  <lucide-icon name="chevron-right" [size]="12" [strokeWidth]="2" class="nsf-breadcrumb-separator"></lucide-icon>
                  <button *ngIf="!last" type="button" class="nsf-breadcrumb-link nsf-breadcrumb-link-tail"
                    [class.nsf-breadcrumb-link--drop-active]="isBreadcrumbDropActive(itemOfBC)"
                    title="{{ itemOfBC.name }}" (click)="goToSpecificLevel(itemOfBC)"
                    (dragover)="onBreadcrumbDragOver($event, itemOfBC)"
                    (dragleave)="onBreadcrumbDragLeave($event, itemOfBC)"
                    (drop)="onBreadcrumbDrop($event, itemOfBC)">
                    <span class="nsf-breadcrumb-label">{{ itemOfBC.name }}</span>
                  </button>
                  <span *ngIf="last" class="nsf-breadcrumb-current nsf-breadcrumb-current-tail" title="{{ itemOfBC.name }}">
                    <span class="nsf-breadcrumb-label">{{ itemOfBC.name }}</span>
                  </span>
                </ng-container>
              </ng-template>
            </div>
          </div>
          <button type="button" class="vf-modal-close-btn" style="flex-shrink:0;" (click)="close()" aria-label="Close">
            <lucide-icon name="x" size="16" [strokeWidth]="2"></lucide-icon>
          </button>
        </div>

        <!-- Toolbar: Create, Upload, Open in SharePoint, Search -->
        <div *ngIf="noOfSelectedItems === 0" class="d-flex align-items-center" style="padding:10px 20px;border-bottom:1px solid #E5E7EB;gap:12px;flex-shrink:0;">
          <!-- Create dropdown (level 1) -->
          <div class="dropdown" *ngIf="level === 1">
            <button class="btn btn-black rounded-sm f-size-14 d-flex align-items-center" type="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              style="height:36px;padding:0 12px;gap:8px;">
              <lucide-icon name="plus" [size]="16" [strokeWidth]="2"></lucide-icon>
              Create
              <lucide-icon name="chevron-down" [size]="16" [strokeWidth]="2" style="margin-left:4px;"></lucide-icon>
            </button>
            <div class="dropdown-menu" style="border-radius:6px;border:1px solid #E5E7EB;box-shadow:0 4px 12px rgba(0,0,0,0.1);">
              <button class="dropdown-item d-flex align-items-center f-size-14 py-2 text-none" (click)="showAddItem(1)">
                <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg" class="w-16 mr-2" alt="word">
                Word
              </button>
              <button class="dropdown-item d-flex align-items-center f-size-14 py-2 text-none" (click)="showAddItem(2)">
                <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg" class="w-16 mr-2" alt="excel">
                Excel
              </button>
              <button class="dropdown-item d-flex align-items-center f-size-14 py-2 text-none" (click)="showAddItem(3)">
                <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg" class="w-16 mr-2" alt="powerpoint">
                Powerpoint
              </button>
              <button class="dropdown-item d-flex align-items-center f-size-14 py-2 text-none" (click)="showAddItem(5)">
                <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="text-gray-400 no-fill"></lucide-icon>
                <span class="text-none ml-2">Create folder</span>
              </button>
              <button class="dropdown-item d-flex align-items-center f-size-14 py-2 text-none" (click)="triggerFileControl()">
                <lucide-icon name="upload" [size]="16" [strokeWidth]="2" class="text-gray-400 no-fill"></lucide-icon>
                <span class="text-none ml-2">Upload files</span>
              </button>
              <input type="file" id="fileUploadOneDrive_Navigate" style="display: none;" multiple
                (change)="fileInputChanged($event, false, level)" />
            </div>
          </div>
          <!-- Create library (level 2) -->
          <button *ngIf="level === 2" class="btn btn-black rounded-sm f-size-14 d-flex align-items-center" type="button"
            style="height:36px;padding:0 12px;gap:8px;" (click)="showAddLibrary()">
            <lucide-icon name="plus" [size]="16" [strokeWidth]="2"></lucide-icon>
            Create
          </button>
          <!-- Upload button -->
          <!-- <button *ngIf="level === 1" type="button" class="d-flex align-items-center f-size-14 text-gray-900 bg-pure-white rounded-sm"
            style="height:36px;padding:0 12px;border:1px solid #E5E7EB;gap:8px;cursor:pointer;"
            (click)="triggerFileControl()">
            <lucide-icon name="upload" [size]="16" [strokeWidth]="2" class="text-gray-600"></lucide-icon>
            Upload
          </button> -->
          <!-- Open Location -->
          <button type="button" class="d-flex align-items-center f-size-14 text-gray-900 bg-pure-white rounded-sm"
            style="height:36px;padding:0 12px;border:1px solid #E5E7EB;gap:8px;cursor:pointer;"
            (click)="openCurrentLocationInM365()">
            <lucide-icon name="external-link" [size]="16" [strokeWidth]="2" class="text-gray-600"></lucide-icon>
            Open Location
          </button>
          <!-- Select button removed — selection column always visible -->
          <!-- Search -->
          <div style="position:relative;margin-left:auto;width:250px;">
            <lucide-icon name="search" [size]="16" [strokeWidth]="2"
              style="position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#9CA3AF;pointer-events:none;"></lucide-icon>
            <input type="text" class="f-size-14" placeholder="Search files..."
              style="width:100%;height:36px;padding-left:36px;padding-right:32px;border:1px solid #E5E7EB;border-radius:4px;outline:none;background:#F3F4F6;"
              (input)="applySearch()" [(ngModel)]="searchText" autocomplete="nope">
            <button *ngIf="searchText" (click)="clearSearch()"
              class="btn btn-link position-absolute text-gray-400 p-0"
              style="right:8px;top:50%;transform:translateY(-50%);">
              <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
            </button>
          </div>
        </div>

        <!-- Body -->
        <div class="nsf-body dragging-area">
          <!-- Multi-select action bar -->
          <div *ngIf="noOfSelectedItems > 0" class="d-flex align-items-center justify-content-between bg-blue-500"
            style="padding:10px 20px;border-bottom:1px solid #2563EB;flex-shrink:0;">
            <div class="d-flex align-items-center flex-wrap" style="gap:4px;">
              <span class="f-size-14 font-weight-medium text-white">
                {{noOfSelectedItems}} {{noOfSelectedItems === 1 ? 'item' : 'items'}} selected
              </span>
              <span style="width:1px;height:16px;background:rgba(255,255,255,0.3);margin:0 8px;"></span>
              <!-- Move to -->
              <div class="dropdown">
                <button class="d-inline-flex align-items-center f-size-14 text-white rounded-sm border-0 bg-transparent hover:bg-blue-600 cursor-pointer"
                  style="padding:6px 12px;gap:6px;transition:background 0.15s;"
                  data-toggle="dropdown">
                  <lucide-icon name="arrow-left-right" [size]="16" [strokeWidth]="2"></lucide-icon>
                  Move to
                  <lucide-icon name="chevron-down" [size]="12" [strokeWidth]="2" style="opacity:0.7;"></lucide-icon>
                </button>
                <div class="dropdown-menu" style="width:288px;border-radius:8px;padding:4px 0;box-shadow:0 4px 16px rgba(0,0,0,0.12);">
                  <div style="padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                    <span class="f-size-12 text-gray-500">Where do you want to move these items?</span>
                  </div>
                  <button class="dropdown-item d-flex align-items-center no-fill" style="padding:12px 12px;gap:12px;" (click)="moveWithinThisFolder()">
                    <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="text-gray-400" style="flex-shrink:0;"></lucide-icon>
                    <div>
                      <div class="f-size-14 text-gray-900 text-none">This location</div>
                      <div class="f-size-12 text-gray-500 text-none" style="margin-top:2px;">Move into a sub-folder here</div>
                    </div>
                  </button>
                  <div style="height:1px;background:#E5E7EB;margin:4px 0;"></div>
                  <button class="dropdown-item d-flex align-items-center no-fill" style="padding:12px 12px;gap:12px;" (click)="moveToDiffLocation()">
                    <lucide-icon name="folder-input" [size]="16" [strokeWidth]="2" class="text-gray-400" style="flex-shrink:0;"></lucide-icon>
                    <div>
                      <div class="f-size-14 text-gray-900 text-none">Different location</div>
                      <div class="f-size-12 text-gray-500 text-none" style="margin-top:2px;">Browse SharePoint or OneDrive</div>
                    </div>
                  </button>
                </div>
              </div>
              <!-- Copy to -->
              <div class="dropdown">
                <button class="d-inline-flex align-items-center f-size-14 text-white rounded-sm border-0 bg-transparent hover:bg-blue-600 cursor-pointer"
                  style="padding:6px 12px;gap:6px;transition:background 0.15s;"
                  data-toggle="dropdown">
                  <lucide-icon name="copy" [size]="16" [strokeWidth]="2"></lucide-icon>
                  Copy to
                  <lucide-icon name="chevron-down" [size]="12" [strokeWidth]="2" style="opacity:0.7;"></lucide-icon>
                </button>
                <div class="dropdown-menu" style="width:288px;border-radius:8px;padding:4px 0;box-shadow:0 4px 16px rgba(0,0,0,0.12);">
                  <div style="padding:10px 16px;border-bottom:1px solid #E5E7EB;">
                    <span class="f-size-12 text-gray-500">Where do you want to copy these items?</span>
                  </div>
                  <button class="dropdown-item d-flex align-items-center no-fill" style="padding:12px 12px;gap:12px;" (click)="copyWithinThisFolder()">
                    <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="text-gray-400" style="flex-shrink:0;"></lucide-icon>
                    <div>
                      <div class="f-size-14 text-gray-900 text-none">This location</div>
                      <div class="f-size-12 text-gray-500 text-none" style="margin-top:2px;">Copy into a sub-folder here</div>
                    </div>
                  </button>
                  <div style="height:1px;background:#E5E7EB;margin:4px 0;"></div>
                  <button class="dropdown-item d-flex align-items-center no-fill" style="padding:12px 12px;gap:12px;" (click)="copyToDiffLocation()">
                    <lucide-icon name="folder-input" [size]="16" [strokeWidth]="2" class="text-gray-400" style="flex-shrink:0;"></lucide-icon>
                    <div>
                      <div class="f-size-14 text-gray-900 text-none">Different location</div>
                      <div class="f-size-12 text-gray-500 text-none" style="margin-top:2px;">Browse SharePoint or OneDrive</div>
                    </div>
                  </button>
                </div>
              </div>
              <span style="width:1px;height:16px;background:rgba(255,255,255,0.3);margin:0 8px;"></span>
              <!-- Download -->
              <button class="d-inline-flex align-items-center f-size-14 text-white rounded-sm border-0 bg-transparent hover:bg-blue-600 cursor-pointer"
                style="padding:6px 12px;gap:6px;transition:background 0.15s;"
                (click)="downloadSelectedItems()">
                <lucide-icon name="download" [size]="16" [strokeWidth]="2"></lucide-icon>
                Download
              </button>
              <span style="width:1px;height:16px;background:rgba(255,255,255,0.3);margin:0 8px;"></span>
              <!-- Delete -->
              <button class="d-inline-flex align-items-center f-size-14 text-white rounded-sm border-0 bg-transparent hover:bg-red-600 hover:text-white cursor-pointer"
                style="padding:6px 12px;gap:6px;transition:background 0.15s;"
                (click)="deleteSelectedItems()">
                <lucide-icon name="trash-2" [size]="16" [strokeWidth]="2"></lucide-icon>
                Delete
              </button>
            </div>
            <!-- Deselect all -->
            <button class="d-flex align-items-center justify-content-center text-white border-0 bg-transparent hover:bg-blue-600 rounded-sm cursor-pointer"
              style="padding:6px;opacity:0.7;flex-shrink:0;margin-left:8px;" title="Cancel selection"
              (click)="clearAllSelectedItems()">
              <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
            </button>
          </div>

          <!-- Drag-drop strip for device-file drags. Always rendered while a device
               drag is in flight so the strip's space stays reserved (toggling its
               *ngIf based on dropTargetItem would reflow the grid mid-drag and
               cause the folder-row highlight to thrash). The folder row itself
               shows its own blue highlight independently when hovered; dropping
               on the strip uploads to the current folder. Default state is light
               grey; hovering the strip switches it to the active blue state and
               swaps the label to "Upload to <folder>". -->
          <div *ngIf="isDragging" class="nsf-drop-strip"
            [class.nsf-drop-strip--active]="stripDragHover"
            (dragenter)="onStripDragEnter($event)"
            (dragover)="$event.preventDefault()"
            (dragleave)="onStripDragLeave($event)"
            (drop)="onCurrentFolderDeviceDrop($event)">
            <lucide-icon name="upload" [size]="16" [strokeWidth]="2" class="nsf-drop-strip__icon"></lucide-icon>
            <span class="f-size-13 nsf-drop-strip__label" *ngIf="!stripDragHover">
              Drop files to upload to <span class="nsf-drop-strip__folder">{{ currentFolderNameForDrop }}</span>
            </span>
            <span class="f-size-13 nsf-drop-strip__label" *ngIf="stripDragHover">
              Upload to <span class="nsf-drop-strip__folder">{{ currentFolderNameForDrop }}</span>
            </span>
          </div>

          <!-- Create form (inline) -->
          <div *ngIf="isShowAddItem && !isDragging" style="padding:12px 20px;border-bottom:1px solid #E5E7EB;flex-shrink:0;">
            <div class="d-flex align-items-center bg-pure-white rounded-sm" style="padding:8px 12px;border:2px solid #D1D5DB;gap:10px;">
              <div class="dropdown">
                <button class="btn p-0" type="button" data-toggle="dropdown">
                  <img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg" *ngIf="selectedDocType === 1" class="w-20" alt="word">
                  <img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg" *ngIf="selectedDocType === 2" class="w-20" alt="excel">
                  <img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg" *ngIf="selectedDocType === 3" class="w-20" alt="powerpoint">
                  <lucide-icon name="folder" [size]="20" [strokeWidth]="2" class="text-gray-400" *ngIf="selectedDocType === 5"></lucide-icon>
                </button>
                <div class="dropdown-menu">
                  <button class="dropdown-item" (click)="selectDocType(1)"><img src="https://cdn.trovve.com/vfapp/images/file-icons/word.svg" class="w-20 mr-10" alt="word"> Word</button>
                  <button class="dropdown-item" (click)="selectDocType(2)"><img src="https://cdn.trovve.com/vfapp/images/file-icons/excel.svg" class="w-20 mr-10" alt="excel"> Excel</button>
                  <button class="dropdown-item" (click)="selectDocType(3)"><img src="https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg" class="w-20 mr-10" alt="powerpoint"> Powerpoint</button>
                  <button class="dropdown-item" (click)="selectDocType(5)"><lucide-icon name="folder" [size]="16" class="mr-2"></lucide-icon> Create folder</button>
                </div>
              </div>
              <input *ngIf="selectedDocType === 5" type="text" class="f-size-14 border-0 bg-transparent" style="flex:1;outline:none;min-width:0;"
                autocomplete="off" [pattern]="pattern" #fileNameInput="ngModel" id="create-file-input"
                name="docu-name" placeholder="Name of folder" maxlength="305" [(ngModel)]="documentName"
                (keypress)="onNewFolderKeyPress($event, false, level)">
              <input *ngIf="selectedDocType !== 5" type="text" class="f-size-14 border-0 bg-transparent" style="flex:1;outline:none;min-width:0;"
                autocomplete="off" [pattern]="pattern" #fileNameInput="ngModel" id="create-file-input"
                name="docu-name" placeholder="Name of document" maxlength="305" [(ngModel)]="documentName"
                (keypress)="onNewFileKeyPress($event, false, level)">
              <button type="button" class="f-size-14 text-pure-white rounded-sm border-0 font-weight-medium"
                [disabled]="isSaving" style="padding:6px 16px;background:#000;white-space:nowrap;cursor:pointer;"
                [style.opacity]="isSaving ? '0.5' : '1'"
                (click)="selectedDocType === 5 ? onNewFolderBlur($event, false, level) : onNewFileBlur($event, false, level)">
                Create
              </button>
              <button type="button" class="f-size-14 text-gray-700 bg-transparent border-0 cursor-pointer"
                (click)="isShowAddItem = false; documentName = '';">
                Cancel
              </button>
            </div>
          </div>

          <!-- Create library form (inline) -->
          <div *ngIf="isShowAddLibrary && !isDragging" style="padding:12px 20px;border-bottom:1px solid #E5E7EB;flex-shrink:0;">
            <div class="d-flex align-items-center bg-pure-white rounded-sm" style="padding:8px 12px;border:2px solid #D1D5DB;gap:10px;">
              <lucide-icon name="folder" [size]="20" [strokeWidth]="2" class="text-gray-400"></lucide-icon>
              <span class="create-input d-flex" style="flex:1;min-width:0;">
                <span class="input-text create-library border-none f-size-14" contenteditable=""
                  style="outline:none;width:100%;"
                  (keypress)="onNewLibKeyPress($event)"></span>
              </span>
              <button type="button" class="f-size-14 text-pure-white rounded-sm border-0 font-weight-medium"
                [disabled]="isSaving" style="padding:6px 16px;background:#000;white-space:nowrap;cursor:pointer;"
                [style.opacity]="isSaving ? '0.5' : '1'"
                (click)="onNewLibBlur($event)">
                Create
              </button>
              <button type="button" class="f-size-14 text-gray-700 bg-transparent border-0 cursor-pointer"
                (click)="isShowAddLibrary = false;">
                Cancel
              </button>
            </div>
          </div>

          <!-- Table header -->
          <!-- AG Grid for files -->
          <div class="nsf-grid-wrapper" style="flex:1 1 0;min-height:0;width:100%;position:relative;"
            (dragover)="onNsfGridDragOver($event)"
            (dragleave)="onNsfGridDragLeave($event)"
            (drop)="onNsfGridDrop($event)">
            <ag-grid-angular #nsfFilesGrid id="nsfFilesGrid"
              class="ag-theme-alpine custom-ag-theme no-border-grid"
              style="width:100%;height:100%;"
              [rowData]="nsfRowData"
              [columnDefs]="nsfColumnDefs" [defaultColDef]="nsfDefaultColDef"
              [rowHeight]="44" [headerHeight]="40"
              [rowSelection]="'multiple'"
              [suppressRowClickSelection]="true"
              [rowMultiSelectWithClick]="false"
              [animateRows]="true" [enableCellTextSelection]="true"
              [rowStyle]="{'cursor': 'pointer'}"
              [getRowClass]="getNsfRowClass"
              [overlayLoadingTemplate]="overlayLoadingTemplate"
              [overlayNoRowsTemplate]="overlayNoRowsTemplate"
              [getContextMenuItems]="getContextMenuItems"
              (gridReady)="onNsfGridReady($event)"
              (rowClicked)="onNsfRowClicked($event)"
              (selectionChanged)="onNsfSelectionChanged()"
              (cellContextMenu)="onNsfCellContextMenu($event)"
              (bodyScroll)="onNsfBodyScroll($event)">
            </ag-grid-angular>
          </div>

          <!-- Loading more shimmer -->
          <div *ngIf="isLoadingMore" style="padding:8px 20px;flex-shrink:0;border-top:1px solid #E5E7EB;">
            <div class="skeleton-shimmer" style="height:40px;border-radius:4px;"></div>
          </div>

          <!-- Footer info bar -->
          <div *ngIf="!isDragging && !isLoading && (driveItems.length > 0 || drives.length > 0)"
            style="padding:12px 20px;border-top:1px solid #E5E7EB;flex-shrink:0;background:#F9FAFB;">
            <p class="f-size-12 text-gray-500 mb-0">Showing {{level === 1 ? driveItems.length : drives.length}} items &middot; Folders appear first &middot; {{nextBatchLink && level === 1 ? 'Scroll to load more' : 'All items loaded'}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<vf-delete-popup [entity]="'Item'" [isOpenFromSlider]="true" [entityObj]="delFileItem"
  (okClick)="okFileBtnClick($event)">
</vf-delete-popup>

<div bsModal #deleteMultipleFilesDeletePopup="bs-modal" class="modal fade center-modal trovve-sm-modal z-index-1110"
  id="nsf_deleteMultipleFilesDeletePopup" tabindex="-1" [config]="{backdrop: 'static',  keyboard: false}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mw-400">
    <div class="modal-content login-modal bg-popup box-shadow-popup border-all">
      <div class="modal-body text-center pb-4">
        <div class="text-center">
          <div class="py-2">
            <h5 class="text-vf-dark font-weight-semibold f-size-16">Are you sure?</h5>
            <p class="f-size-14 mt-3 text-vf-dark mb-2">
              Do you want to delete all the selected items?
            </p>
          </div>
          <div class="d-flex flex-column mt-3">
            <button type="button" class="btn btn-danger rounded-8 py-10 w-100 mb-2" [disabled]="isDeleting"
              (click)="deleteMultipleFiles()">
              Yes, delete
            </button>
            <button type="button" class="btn cancel-btn rounded-8 py-10 w-100"
              (click)="deleteMultipleFilesDeletePopup.hide()">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<vf-info-popup [information]="information" [isShow]="isShowInfoPopup" (okClick)="isShowInfoPopup = false">
</vf-info-popup>
<vf-modal-shell #errorShell
  [failure]="true"
  [title]="errorTitle"
  [message]="currentError?.message"
  [cancelLabel]="currentError?.cancelLabel"
  [saveLabel]="currentError?.saveLabel"
  (cancelClick)="closeError()"
  (saveClick)="saveError()">
</vf-modal-shell>
